import Header from './Header'
const UpdatePassword = () => {
    return (
        <div className="best">
            <Header />
            <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li>
                    <li>Update Password</li>
                </ul>
            </div>
        </div>

        <div className="wrapbox">
            <div className="wrapper">

                <form action="#" className="form-group updatepassarea">

                    <input type="text" placeholder="Email/Mobile No" className="passwordbox widthset" />
                    <a href="#" type="submit" className="btn btn-primary signinbtn"><i>Next</i></a>
                </form>

            </div>
        </div>

        </div>
    );
};
  
export default UpdatePassword;